import { h } from 'preact'
import { ArticleEdit, GroupedEdits } from './types'
import ArticleEditListItem from './ArticleEditListItem'

type Props = {
  edits: GroupedEdits,
  latestEdit: string | undefined,
  selectedEdit: string | undefined,
  onItemClicked: (editedAt: string) => void
}

export default ({ edits, latestEdit, selectedEdit, onItemClicked }: Props) =>
  <div class='article-versions__edit-list'>
    {
      Object.entries(edits).map((edit) => {
        const groupName = edit[0]
        const editList = edit[1]
        return (
          editList.length > 0 && <div>
            <div className='article-versions__edit-list-group'>{groupName}</div>
            {
              editList.map((edit: ArticleEdit) => <ArticleEditListItem
                editedAt={edit.edited_at}
                editedBy={edit.edited_by}
                isLatest={edit.edited_at === latestEdit}
                isSelected={edit.edited_at === selectedEdit}
                onClick={onItemClicked}
              />)
            }
          </div>
        )
      })
    }
  </div>
